import { findEmployeesWithFields } from "../../../infrastructure/employees-cache";
import adaptEmployees from "../../../infrastructure/adapters/adaptEmployees";

export default async function fetchEmployees({
  companyId,
  callback,
}: {
  companyId: string;
  callback(e: any): void;
}) {
  const data = await findEmployeesWithFields({ companyId });
  callback(adaptEmployees({ employees: data }));
}
